import * as React from "react";

import Footer from "./Footer";
import Header from "./Header";
import MetaDescription from "./util/components/MetaDescription";
import { useWordpressPage } from "./util/hooks/useWordpressPage";

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
interface Props {
  id: number;
  // eslint-disable-next-line  @typescript-eslint/consistent-indexed-object-style
  className?: string;
}

const WordpressPage = ({ id, className }: Props) => {
  const html = useWordpressPage(id);

  return (
    <div>
      <MetaDescription content="Duolingo" title="Duolingo" />
      <Header />
      <div
        className={className}
        // eslint-disable-next-line @typescript-eslint/naming-convention
        dangerouslySetInnerHTML={{ __html: html }}
      />
      <Footer />
    </div>
  );
};

export default WordpressPage;
